export default "__VITE_ASSET__CO71x$ab__"